// extracted by mini-css-extract-plugin
export default {"heading":"MenuSection_heading__i0TqW","separator":"MenuSection_separator__0IjQZ","section":"MenuSection_section__zAO2+"};